import { render } from "./PropertyMapper.vue?vue&type=template&id=283c712a&scoped=true"
import script from "./PropertyMapper.vue?vue&type=script&lang=js"
export * from "./PropertyMapper.vue?vue&type=script&lang=js"

import "./PropertyMapper.vue?vue&type=style&index=0&id=283c712a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283c712a"]])

export default __exports__